export default {
  packageCard: {
    Subscription: {
      month: '/月',
    },
    BuyNow: '立即购买',
    permission: {
      ve: '视频制作',
      vrec: '录屏工具',
      insights: '创意洞察',
      gm: '可玩制作',
      assets: '创意资产库',
      packbuy: '套餐加量包',
    },
    packageInfo: {
      validity: '有效期1年',
      download: {
        amount: '总计{total}条',
      },
      mtgCharge: {
        noChange: '{baseMessage}{br}',
        change: '{baseMessage}可玩下载&推送',
        notes: '(Mintegral推送不限制)',
        notesTip: '不限制Mintegral渠道素材推送次数',
      },
      videoCredits: {
        amount: '总计{totalPoints}点',
      },
    },
    download: {
      tabType: {
        subscription: '可玩下载&{br}推送/月',
        normal: '可玩下载&{br}推送',
      },
    },
    videoCredits: {
      tabType: {
        subscription: '点数/月',
        normal: '点数',
      },
    },
    storage: {
      amount: '存储空间',
      space: '{amount}G',
    },
    online: {
      amount: '登录人数',
    },
    grantLabel: {
      hot: '热门套餐',
      recommend: '推荐套餐',
    },
  },
  selectPackage: {
    title: '请选择适合你的套餐',
    tabType: {
      subscription: {
        quarter: '按季度订阅',
        annualized: '按年订阅 (节省20%)',
      },
    },
    tabs: {
      tabType: {
        personal: '按数量购买(个人)',
        enterprise: '按数量购买(企业)',
        subscription: '按时长订阅(企业)',
      },
    },
    contract: {
      dialog: {
        title: '购买套餐',
        message: '您暂无权限购买，可在线留言联系我们。',
      },
    },
    isEnterprise: {
      dialog: {
        message: '您已有订阅套餐，无法重复购买。您可购买加量包提升权益。',
        confirmbtn: '购买',
      },
    },
  },
  subscription: {
    package: {
      title: '购买加量包',
      description:
        '*订阅套餐一个月按照30天算，套餐不够用可补充购买加量包：可玩下载/推送：{currency}{pushPrice}/条，加点数：{currency}{AddPrice}/5000点，存储空间升级至200G：{currency}{storagePrice}/月',
      tooltip: '订阅套餐后可购买',
      contact: {
        text: '需要更多？联系我们获取企业定制套餐方案',
        button: '立即联系',
      },
    },
  },
  record: {
    payment: {
      status: {
        pending: '待支付',
        success: '支付成功',
        failed: '支付失败',
        canceled: '已取消',
        warning: '支付确认中',
      },
      statusTip: {
        warning:
          '三方支付渠道需要一定时间来确认款项到账。支付成功后，系统将自动激活套餐授权或充值账户余额。',
      },
    },
    grantOrderType: {
      packBuy: '购买加量包',
      packageBuy: '购买套餐',
      recharge: '充值',
    },
    page: {
      title: '购买历史',
      search: {
        preLabel: '支付状态',
        placeholder: '全部',
      },
    },
    table: {
      name: '名称',
      tooltip: {
        downloadPush: '可玩下载&推送：{download_push}条',
        videoCredits: '点数：{video_credits}',
      },
      bill: {
        amount: '账单金额',
      },
      operation: '操作',
      package: {
        validity: '套餐有效期',
      },
      update: {
        time: '更新时间',
      },
      payAgain: '重新支付',
    },
    cancelPayment: {
      dialog: {
        title: '取消订单',
        message: '取消后该笔订单不能再次支付，是否确认取消？',
        confirmbtn: '确认',
        tip: '取消成功',
      },
    },
  },
  grantDialog: {
    partnerName: '客户名称',
    package: {
      info: '订单信息',
      firstTips: '购买个人套餐后，该账号不能用于购买企业套餐',
      validityDays: '有效期：',
      amount: '充值金额：',
    },
    packBuy: {
      info: '请选择所需补充购买内容和数量',
    },
    desc: '因本合作产生的任何政府税费，包括但不限于预提税、商品及服务税、增值税等均由您承担。',
    countTips: '请选择所需购买的数量',
    submit: '确认，选择付款方式',
    minAmountTip: '最低金额 US{min_amount}',
    agree: '请勾选Playturbo会员服务协议',
    partnerCodeTip: '请勾选客户名称',
    amountTips: '请输入充值金额',
    recharge: '在线充值',
    packTable: {
      price: '单价',
      count: '数量',
      storageTips: '您订阅的套餐有效期还有{quantity}个月',
      amount: '价格',
      name: '名称',
      downloadPush: '加可玩下载&推送',
      renderVideo: '加点数',
      storageUpgrade: '存储空间升级至{storage}G',
    },
    packageTable: {
      days: '{days}天',
    },
    totalFooter: {
      price: '价格 (不含税)',
    },
    downloadPushUnit: '{count}条',
    renderVideoUnit: '{count}点',
    storageUnit: '{count}个月',
    amountTips2: '仅支持输入数字',
  },
  checkGrant: {
    success: '支付成功',
    successMessage: '您已成功支付，订单支付状态刷新可能存在延迟，请耐心等待。',
    successConfirm: '我知道了',
    failedMessage: '购买失败',
  },
  router: {
    title: '购买套餐',
  },
  profile: {
    form: {
      usertype: {
        title: '账号类型',
        personal: '个人用户',
        organization: '企业用户',
      },
      contactQuestion: '想成为Playturbo企业用户?',
      contactUs: '联系我们',
    },
  },
}
